import { ADD_TRANSPORT_QUOTATIONS } from "./TransportQuotations.saga";

const getTransportQuotations = (payload) => ({
  type: ADD_TRANSPORT_QUOTATIONS.LOADING,
  payload,
});

export default getTransportQuotations;
